import React from "react";
import { CheckmarkIcon } from "modules/icons";
import useStyles from "./styles";

export const CheckIcon: React.FC = () => {
  const { classes } = useStyles();
  return <CheckmarkIcon className={classes.checkmark} />;
};
